import { UserApp } from "../../UserApp";
import { ReminderUI } from "../ui/reminder-ui";
import { MailEntry } from "./data/MailEntry";
import { ReminderData } from "./data/ReminderData";
import { ReminderEntry } from "./data/ReminderEntry";

export class ReminderApp extends UserApp<ReminderData,ReminderUI>
{
  constructor()
  {
    super( "reminder", ReminderUI );
  }

  _editMailEntry:MailEntry;

  createNewMailEntry()
  {
    this._editMailEntry = MailEntry.create();
    this._editMailEntry.date = "Now";
    this._editMailEntry.subject = "Subject";
    this._editMailEntry.message = "Hello!";
  }

  ensureData()
  {
    if ( this.data )
    {
      return;
    }

    this._userData = ReminderData.create();
  }

  get entries():ReminderEntry[]
  {
    let all:ReminderEntry[] = [].concat( this.data.mailEntries );

    return all;
  }

 
}